
/*------------------------------------------------------------------
Import external
------------------------------------------------------------------*/

import $ from 'jquery';
import GLightbox from 'glightbox';

/*------------------------------------------------------------------
Doc Ready
------------------------------------------------------------------*/

$(() => {


    let images = [];

    $('.gallery__wrap__item').each((i, el) => {
        images.push({ 'href': $(el).attr('data-lightbox-image'), 'type': 'image', title: $(el).attr('data-name') })
    });

    const myGallery = GLightbox({
        height: '90%',
        slideEffect: 'fade',
        touchNavigation: true,
        loop: true,
        elements: images
    });

    $('body').on('click', '.gallery__wrap__item', (e) => {
        e.preventDefault();
        let $this = $(e.currentTarget)
        myGallery.openAt($this.index());
    });
});
